import { render, staticRenderFns } from "./newButtonCheckGroup.vue?vue&type=template&id=4d2b89fa&scoped=true"
import script from "./newButtonCheckGroup.vue?vue&type=script&lang=js"
export * from "./newButtonCheckGroup.vue?vue&type=script&lang=js"
import style0 from "./newButtonCheckGroup.vue?vue&type=style&index=0&id=4d2b89fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b89fa",
  null
  
)

export default component.exports